export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7320.77a96030.jpg";